// Desc: This component is responsible for editing data in the RAD
// It might be ugly but it works, unlike most of the copilot generated drivel.

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useRADDispatch } from "../RADHandler/contexts/RADDispatchContext.jsx";
import { useRADSelection } from "../RADHandler/contexts/RADSelectionContext.jsx";
import { useMessages } from "@cadenza/messages";

import { CSButton } from "@cadenza/ui";

const RADDataEditor = ({ words }) => {
  const { NAME, DESCRIPTION, VIEWPOINT } = words;
  const { state, updateRADInfo } = useRADDispatch();
  const { selectedComponent } = useRADSelection();
  const { id, info } = state || {};

  const [formData, setFormData] = useState(info || {});
  const [active, setActive] = useState(false);
  const { success, error } = useMessages();

  const handleDataChange = useCallback((event) => {
    const name = event.target.name;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    setFormData((values) => ({ ...values, [name]: value }));
    setActive(true);
  }, []);

  const handleComponentReset = useCallback(() => {
    // back out current changes
    setFormData(info || {});
    setActive(false);
  }, [info]);

  const prevRadId = useRef();
  useEffect(() => {
    if (prevRadId.current !== id) {
      setFormData(info || {});
      prevRadId.current = id;
    }
  }, [id, info]);

  const handleSubmit = (event) => {
    // Save the changes to the selected component.
    event.preventDefault();
    console.log("Submitting form data:", formData);
    const result = updateRADInfo(formData);
    if (result?.success) {
      success(result.message);
    } else {
      error(result?.message || "Failed to update RAD info");
    }
    setActive(false);
  };

  const handleKeyDown = useCallback((event) => {
    const trimmedText = event.target.value.trim();
    if ((event.key === "Enter" || event.key === "Tab") && trimmedText) {
      event.preventDefault();
      // Step to the next field.
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
    }
  }, []);

  return (
    <>
      {!selectedComponent && (
        <div className="rad-data-container">
          {id && (
            <>
              <h3>RAD Editor</h3>
              <fieldset>
                <label>
                  ID:
                  <input type="text" name="id" value={id} disabled />
                </label>
                <br />
                {!formData.process_id && (
                  <label>
                    {NAME}:
                    <input
                      type="text"
                      name="name"
                      value={formData?.name || ""}
                      placeholder="Enter a new value..."
                      onChange={handleDataChange}
                      pattern="[ a-zA-Z0-9_\-]+"
                      onKeyDown={handleKeyDown}
                      disabled={!id}
                    />
                  </label>
                )}
                <label>
                  {DESCRIPTION}:
                  <textarea
                    name="description"
                    value={formData?.description || ""}
                    onChange={handleDataChange}
                    onKeyDown={handleKeyDown}
                    disabled={!id}
                  />
                </label>
                <label>
                  {VIEWPOINT}:
                  <textarea
                    name="viewpoint"
                    value={formData?.viewpoint || ""}
                    onChange={handleDataChange}
                    disabled={!id}
                  />
                </label>
                <div className="button-container">
                  <CSButton
                    onClick={handleSubmit}
                    disabled={!formData || !active}
                  >
                    Save
                  </CSButton>
                  <div className="right-buttons">
                    <CSButton
                      type="button"
                      disabled={!formData || !active}
                      onClick={handleComponentReset}
                    >
                      Reset
                    </CSButton>
                  </div>
                </div>
              </fieldset>
              {/* {!active && <AddRoleButton />} */}
              {/* <RoleSelector /> */}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default RADDataEditor;
